/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	window.mecCo = {
	  breakpoint: 720
	};
	
	// modules
	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	
	$('.js-drawer').each(function(){
	  new OpenDrawer(this, {bp: window.mecCo.breakpoint});
	});
	
	$('.js-scroll-btn').each(function(){
	  new Scroll(this, {
	    stopEl: $(this).data('stop'),
	    isHidden: $(this).data('hidden')
	  });
	});
	
	$('.l-header-pcnav_L3Link').on('touchstart',function(){
	  var url = $(this).attr("href");
	  location.href = url;
	});
	
	$('.js-Slider').each(function(){
	  new Slider(this, {bp: window.mecCo.breakpoint});
	});
	
	$('.js-Accordion').each(function(){
	  new Accordion(this, {parent: true});
	});
	
	$('.js-ExpandNav').each(function(){
	  new ExpandNav(this, {bp: window.mecCo.breakpoint});
	});
	
	$('.js-mecInfo_navTab li').click(function(){
	  var tab_id = $(this).attr('data-tab');
	  $('.js-mecInfo_navTab li').removeClass('current');
	  $('.js-infoTopics_Content').removeClass('current');
	  $(this).addClass('current');
	  $("#"+tab_id).addClass('current');
	});
	
	$('.js-faq_Content').on('click', function(){
	  var answer = $(this).next();
	  if($(this).hasClass('p-faq_active')) {
	    var itemHeight = answer.height();
	    answer.animate({
	      marginTop: "-"+itemHeight+"px",
	    },500);
	  } else {
	    answer.show();
	    answer.animate({
	      marginTop: 0,
	    }, 500);
	  }
	  $(this).toggleClass('p-faq_active');
	});
	$('.js-faq_Answer').hide(0,function(){
	  var content = $(this).prev();
	  var answer = $(this);
	  var itemHeight = answer.height();
	  answer.animate({
	    marginTop: "-"+itemHeight+"px",
	  },10);
	  content.toggleClass('p-faq_active');
	});
	
	(function ($) {
	  $.fn.extend({
	    openPopup: function (options) {
	      var defaults = {}
	      var options = $.extend(defaults, options);
	      return this.each(function () {
	        var obj = $(this);
	        //open popup
	        obj.click(function () {
	          var idPopup = $(this).attr('data-popup');
	          if (idPopup != '#') {
	            if (idPopup.length >= 1) {
	              if (!$(idPopup).hasClass('is-Active_Item')) {
	                $(idPopup).addClass('is-Active_Item');
	                $(idPopup).parent().addClass('is-Active_Popup');
	              }
	            }
	          }
	        });
	        //close popup
	        var btnClosePopup = $('.js-ClosePopup');
	        if (btnClosePopup.length >= 1) {
	          btnClosePopup.click(function () {
	            var boxPopupContent = $(this).parents('.is-Active_Popup');
	            boxPopupContent.removeClass('is-Active_Popup').find('.is-Active_Item').removeClass('is-Active_Item');
	          });
	        }
	      });
	    }
	  });
	
	})(jQuery);
	
	$('.js-eSchoolCourse_Popup_Open,.js-popup_open').openPopup();


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/**
	* ドロワーのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	* @param {options} object - オプション
	*/
	module.exports = OpenDrawer = function(el, options){
	  this.element = $(el);
	  this.breakpoint = (options.bp) ? options.bp : 1024;
	  this.init();
	};
	
	/**
	* initialize
	*/
	OpenDrawer.prototype.init = function(){
	  this.win = $(window);
	  this.body = $('body');
	  this.btn = $('.js-drawer-btn');
	  this.overlay = $('.js-drawer-overlay');
	  this.drawer = this.btn.next();
	  this.event();
	};
	
	/**
	* event
	*/
	OpenDrawer.prototype.event = function(){
	  var self = this;
	
	  self.btn.prop('checked', false).on('change', function(e){
	    var $drawer = $(this).next();
	    var direction = $(this).data('drawer-direction');
	    // var $elements = self.element.add(self.overlay);
	    var $elements = self.overlay;
	
	    if($(this).prop('checked')){
	      self.openDrawer($drawer, direction, $elements);
	    }else{
	      self.closeDrawer($elements);
	    }
	  });
	
	  self.overlay.on('click', function(e){
	    e.preventDefault();
	    var $elements = [self.element, self.drawer, $(this)];
	    self.closeDrawer($elements);
	    self.btn.prop('checked', false);
	  });
	
	  var timer = false;
	  self.win.on('resize', function() {
	    if (timer !== false) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function() {
	      if (self.win.width() >= self.breakpoint && self.btn.prop('checked')) {
	        self.overlay.trigger('click');
	      }
	    }, 200);
	  });
	};
	
	/**
	* open drawer
	*/
	OpenDrawer.prototype.openDrawer = function(drawer, direction, elms){
	  var self = this;
	  self.scrollTop = self.win.scrollTop();
	  self.body.css({'top': -self.scrollTop});
	
	  var drawerWidth = this.getDrawerWidth();
	  var translateValue = (direction === 'left') ? drawerWidth + 'px, 0' : '-' + drawerWidth + 'px, 0';
	  var drawerStyles = {};
	  drawerStyles.transform = 'translate(' + translateValue + ')';
	  drawerStyles['margin-' + direction] = '-' + drawerWidth + 'px';
	  $(drawer).css(drawerStyles);
	  // $(elms).css('transform', 'translate('+translateValue+')');
	  self.body.addClass('is-locked');
	  self.overlay.addClass('is-visible');
	};
	
	/**
	* close drawer
	*/
	OpenDrawer.prototype.closeDrawer = function(array){
	  var self = this;
	  for(var i = 0; i < array.length; i++){
	    array[i].removeAttr('style');
	  }
	  self.body.removeClass('is-locked');
	  self.overlay.removeClass('is-visible');
	
	  self.body.css({'top': ''});
	  self.win.scrollTop(self.scrollTop);
	};
	
	/**
	* get drawer width
	*/
	OpenDrawer.prototype.getDrawerWidth = function(){
	  return this.drawer.outerWidth();
	};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/**
	* ページトップのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = Scroll = function(el, options){
	  this.element = $(el);
	  this.stopEl = (options.stopEl) ? $(options.stopEl) : null;
	  this.isHidden = (options.isHidden) ? $(options.isHidden) : false;
	  this.init();
	};
	
	/**
	* init
	*/
	Scroll.prototype.init = function(){
	  this.win = $(window);
	  this.doc = $(document);
	  this.event();
	};
	
	/**
	* event
	*/
	Scroll.prototype.event = function(){
	  var self = this;
	
	  // if(!this.stopElement.length) return;
	
	  var visible = 'is-visible';
	  var absolute = 'is-absolute';
	
	  var winHeight = this.win.height();
	  var stopPos = 0;
	  var currentPos;
	
	  self.element.on('click', function(e){
	    var pos = (self.stopEl) ? self.stopEl.offset().top : 0;
	    e.preventDefault();
	    $('html, body').animate({scrollTop: pos}, 300, 'swing');
	    return false;
	  });
	
	  self.win.on({
	    // 'load': function(){
	    //   stopPos = self.stopElement.offset().top + self.element.outerHeight();
	    // },
	    'scroll touchmove': function(){
	      currentPos = $(this).scrollTop();
	      if(currentPos > 20){
	        self.element.addClass(visible);
	      }else{
	        self.element.removeClass(visible);
	      }
	      // if(currentPos + winHeight > stopPos){
	      //   self.element.addClass(absolute).css('top', stopPos - self.element.outerHeight());
	      // }else{
	      //   self.element.removeClass(absolute).removeAttr('style');
	      // }
	    }
	  });
	};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	* スライダーのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	* @param {options} object - オプション
	*/
	module.exports = Slider = function(el, options){
	  this.element = $(el);
	  this.breakpoint = options.bp;
	  this.media = this.element.data('media');
	  this.type = this.element.data('type');
	  switch (this.type) {
	    case 'bnr':
	      this.sliderSettings = {
	        centerMode: true,
	        slidesToShow: 1,
	        accessibility: false,
	        autoplay: true,
	        autoplaySpeed: 5000,
	        arrows: false,
	        slide: 'a',
	        variableWidth: true,
	        pauseOnHover: false
	      };
	      break;
	    case 'mv':
	      this.sliderSettings = {
	        centerMode: true,
	        slidesToShow: 1,
	        accessibility: false,
	        autoplay: true,
	        autoplaySpeed: 5000,
	        arrows: false,
	        slide: 'div',
	        variableWidth: true,
	        dots: true,
	        centerPadding: '0',
	        fade: true,
	        arrows: false,
	        draggable: false,
	        touchMove: false,
	        pauseOnHover: false
	      };
	      break;
	    default:
	      this.sliderSettings = {};
	  }
	  this.win = $(window);
	  this.init();
	};
	
	/**
	* init
	*/
	Slider.prototype.init = function(){
	  var self = this;
	  self.onResize();// どのみち一度は走るので
	
	  if (self.media !== undefined) {
	    var timer = false;
	    self.win.on('resize', function() {
	      if (timer !== false) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function() {
	        // console.log('resized');
	        self.onResize();
	      }, 200);
	    });
	  }
	};
	
	/**
	* event
	*/
	Slider.prototype.event = function(param){
	  var self = this;
	  var options = (param === true) ? self.sliderSettings : 'unslick';
	  // console.log(self.element);
	  self.element.slick(options);
	};
	
	/**
	* resize
	*/
	Slider.prototype.onResize = function(){
	  var self = this;
	
	  var w = self.win.width();
	  var isEnabledVP;
	  switch (self.media) {
	    case 'pc':
	      isEnabledVP = (w >= self.breakpoint);
	      break;
	    case 'sp':
	      isEnabledVP = (w < self.breakpoint);
	      break;
	    default:
	      isEnabledVP = true;// サイズにかかわらず有効の意
	  }
	
	  if (isEnabledVP && self.enabled !== true) {
	    self.event(true);
	    self.enabled = true;
	  } else if (!isEnabledVP && self.enabled === true) {
	    self.event(false);
	    self.enabled = false;
	  }
	};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	* アコーディオンのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = Accordion = function(el, options){
	  this.element = $(el);
	  this.speed = (this.element.data('slidespeed')) ? this.element.data('slidespeed') : 200;
	  this.target = this.element.data('acctarget');
	  // console.log(this.target);
	  this.targetEl = (this.target !== undefined) ? $('.js-AccordionTarget[data-acctarget="' + this.target + '"]') : this.element.next();
	  this.trigger = this.element.data('acctrigger');
	  this.options = options;
	  if (this.options.parent === true) {
	    this.parent = this.element.parent();
	  }
	  this.init();
	};
	
	Accordion.prototype.init = function(){
	  var self = this;
	
	  switch (self.trigger) {
	    case 'hover':
	      self.element.on('mouseenter touchstart', function(e) {
	        e.preventDefault();
	        self.event(true);
	        // return false;
	      });
	      self.element.on('mouseleave', function(e) {
	        e.preventDefault();
	        self.event(false);
	        // return false;
	      });
	      break;
	    default:
	      self.element.on('click', function(e) {
	        e.preventDefault();
	        self.event(null);
	        return false;
	      });
	  }
	};
	
	Accordion.prototype.event = function(stat){
	  var self = this;
	
	  self.element.toggleClass('is-Open', stat);
	  if (self.parent) {
	    self.parent.toggleClass('is-Open', stat);
	  }
	
	  switch (stat) {
	    case true:
	      self.targetEl.slideDown(self.speed);
	      break;
	    case false:
	      self.targetEl.slideUp(self.speed);
	      break;
	    default:
	      self.targetEl.slideToggle(self.speed);
	  }
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/**
	* PCのグローバルナビのホバーエフェクト
	* @constructor
	* @param {selector} el - セレクタ
	* @param {options} object - オプション
	*/
	module.exports = ExpandNav = function(el, options) {
	  this.element = $(el);
	  this.breakpoint = options.bp;
	  this.group = this.element.data('navgroup');
	  this.target = $('.js-ExpandNavTarget[data-navgroup="' + this.group + '"]');
	  this.children = $('.js-ExpandNavTarget');
	  this.win = $(window);
	  this.init();
	};
	/**
	* init
	*/
	ExpandNav.prototype.init = function() {
	  var self = this;
	
	  var timer = false;
	  self.element.on('mouseenter touchstart', function() {// touchstartはタブレット対応
	    // console.log('element on');
	    // マウスがちょっとブレて上を通過したくらいでは開かないようタイマー設定
	    if (timer !== false) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function() {
	      self.deactivateAll();
	      self.activate();
	    }, 150);
	  });
	  // 250ms以内にカーソルが出ていったら開かない、開いていたら閉じる
	  self.element.on('mouseleave', function() {
	    // console.log('element off');
	    if (timer !== false) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function() {
	      self.deactivate();
	    }, 1000);
	  });
	
	  self.target.on('mouseenter touchstart', function() {
	    // console.log('target on');
	    if (timer !== false) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function() {
	      self.deactivateAll();
	      self.activate();
	    }, 150);
	  });
	  self.target.on('mouseleave', function() {
	    // console.log('target off');
	    if (timer !== false) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function() {
	      self.deactivate();
	    }, 1000);
	  });
	
	  var timer2 = false;
	  self.win.on('resize', function() {// SPビューになったら全部閉じる
	    if (timer2 !== false) {
	      clearTimeout(timer2);
	    }
	    timer2 = setTimeout(function() {
	      self.onResize();
	    }, 100);
	  });
	};
	
	/**
	* activate
	*/
	ExpandNav.prototype.activate = function() {
	  var self = this;
	  if (self.target.hasClass('is-Active')) return false;
	  self.target.addClass('is-Active');
	};
	
	/**
	* deactivate
	*/
	ExpandNav.prototype.deactivate = function() {
	  var self = this;
	  self.target.removeClass('is-Active');
	};
	
	/**
	* deactivate all
	*/
	ExpandNav.prototype.deactivateAll = function() {
	  var self = this;
	  self.children.removeClass('is-Active');
	};
	
	/**
	* resize
	*/
	ExpandNav.prototype.onResize = function() {
	  var self = this;
	
	  var w = self.win.width();
	  var isEnabledVP = (w >= self.breakpoint);
	
	  if (w < self.breakpoint) {
	    self.deactivateAll();
	  }
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.js